<script lang="ts" setup>
// SolfigrIcmMessages
import { t } from '@/locales/i18n'
import { RouterLink } from 'vue-router'

export interface Props {
  messages: 'upgrade_to_elite_mtt_unlock_icm_tournament_search'
}
withDefaults(defineProps<Props>(), {
  messages: 'upgrade_to_elite_mtt_unlock_icm_tournament_search',
})
</script>

<template>
  <div class="gw_mesblock_container flex-1">
    <div
      v-if="messages.includes('upgrade_to_elite_mtt_unlock_icm_tournament_search')"
      class="gw_mesblock flex-1 pa-4"
      data-tst="upgrade_to_elite_mtt_unlock_icm_tournament_search"
    >
      <div
        class="gw_mesblock_title"
        data-tst="upgrade_to_elite_unlock_custom_solutions"
        v-html="t(`messages.upgrade_to_elite_mtt_unlock_icm_tournament_search`)"
      ></div>

      <RouterLink
        class="gw_btn gw_btn-v1 w-100 gw_btn_primary weight_500 mt-4 clr-white"
        style="--padding: 1.5rem; font-size: 1rem"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: 'mtt' },
        }"
      >
        <i class="mdi text-large mdi-crown mr-2"></i>
        {{ t('btn.go_elite') }}
      </RouterLink>
    </div>
  </div>
</template>
